import { assign, createMachine } from 'xstate';
import { Context } from './types';
import { updateCustomFields } from '@chargify/custom-fields';

const customFields = createMachine<Context>({
  id: 'customFields',
  predictableActionArguments: true,
  context: {
    customFields: null,
  },
  initial: 'idle',
  states: {
    idle: {
      on: {
        INITIALIZE: {
          target: 'loading',
        },
        EDIT_CUSTOM_FIELDS: {
          target: 'customFieldsEdit',
        },
      },
    },
    loading: {
      invoke: {
        src: 'getCustomerCustomFields',
        onDone: {
          target: 'idle',
          actions: assign((_ctx, event) => {
            return {
              customFields: event.data.items,
            };
          }),
        },
        onError: {
          target: 'error',
        },
      },
    },
    error: {
      on: {
        INITIALIZE: {
          target: 'loading',
        },
      },
    },
    customFieldsEdit: {
      id: 'customFieldsEdit',
      initial: 'idle',
      states: {
        idle: {
          on: {
            SAVE: {
              target: 'saving',
            },
            CANCEL: {
              target: '#customFields',
            },
          },
        },
        saving: {
          invoke: {
            src: 'saveCustomerCustomFields',
            onDone: {
              target: '#customFields.idle',
              actions: [
                assign((ctx, event) => {
                  return {
                    customFields: updateCustomFields(
                      ctx.customFields,
                      event.data.fields
                    ),
                  };
                }),
                'onSuccessUpdate',
              ],
            },
            onError: {
              target: 'error',
            },
          },
        },
        error: {
          on: {
            CANCEL: {
              target: '#customFields',
            },
            SAVE: {
              target: 'saving',
            },
          },
        },
      },
    },
  },
});

export { customFields };
